import { GenericLink } from '@nextgen-web-framework/all';
import { TextCardProps } from './types/propTypes';
import styles from './TextCard.module.scss';

const TextCard = ({ description, title, link }: TextCardProps) => (
  <div className={`${styles.textCard} text-card-content-search`}>
    <GenericLink href={link}>
      <div className={styles.title}>{title}</div>
      <p className={styles.details}>{description}</p>
    </GenericLink>
  </div>
);

export default TextCard;
export type { TextCardProps };
